module.exports = __webpack_public_path__ + "static/media/delete-icon.365efea7.svg";